// material-ui
import Chip from '@mui/material/Chip';
import useMediaQuery from '@mui/material/useMediaQuery';
import Box from '@mui/material/Box';

// third-party
import useSWR from 'swr';

// project imports
import Breadcrumbs from 'components/@extended/Breadcrumbs';
import Profile from './Profile';
import MobileSection from './MobileSection';
import OrgRoleSwitcher from './OrgRoleSwitcher';
import { getDistributorContext } from 'services/adToolsApi';

// 合作方归属角标:站点右上角展示当前绑定合作方名称(去掉"绑定合作方:"前缀,组织架构页内不再展示该文案)
function PartnerBadge() {
  const { data } = useSWR('distributor-context', () => getDistributorContext(), {
    revalidateIfStale: false,
    revalidateOnFocus: false,
    revalidateOnReconnect: false,
    shouldRetryOnError: false
  });
  const payload = data?.data || data || null;
  const partner = payload?.partner || null;
  if (!partner?.name) return null;
  return (
    <Chip
      size="small"
      variant="outlined"
      color="warning"
      label={partner.name}
      sx={{ height: 28, flexShrink: 0, '& .MuiChip-label': { fontSize: 12 } }}
    />
  );
}

// ==============================|| HEADER - CONTENT ||============================== //

export default function HeaderContent() {
  const downLG = useMediaQuery((theme) => theme.breakpoints.down('lg'));

  return (
    <>
      <Breadcrumbs card={false} divider={false} title={false} sx={{ mb: 0, ml: 1, display: 'flex', alignItems: 'center' }} />
      <Box sx={{ flexGrow: 1 }} />
      {/* 组织/角色切换在合作方名称左侧，参考 vben 右上角 */}
      {!downLG && <OrgRoleSwitcher />}
      {!downLG && <PartnerBadge />}
      {!downLG && <Profile />}
      {downLG && <MobileSection />}
    </>
  );
}
